






































































































import {
  computed, defineComponent, onMounted, reactive, ref, watch,
} from '@vue/composition-api';

import { getMe } from '@/api';
import useAuth from '@/use/useAuth';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import CommonPartOfSidebar from '@/components/CommonPartOfSidebar.vue';
import CommonSmallPartOfSidebar from '@/components/CommonSmallPartOfSidebar.vue';

const AppFast = defineComponent({
  components: {
    CommonModalWithPreset,
    CommonPartOfSidebar,
    CommonSmallPartOfSidebar,
  },
  setup(props, { root }) {
    const { hasPermission: checkPermissionHandler } = useAuth();
    function hasPermission(name: string) {
      return checkPermissionHandler(root.$store.getters.me, name);
    }

    const dashboard = computed(() => root.$store.getters.dashboard || []);

    async function setAvailableDashboard() {
      const result = [];
      if (hasPermission('dashboard.purchase')) result.push('purchase');
      if (hasPermission('dashboard.prod')) result.push('prod');
      if (hasPermission('dashboard.store')) result.push('store');
      root.$store.commit('setDashboard', result);
    }

    const me = ref({});
    onMounted(async () => {
      me.value = await getMe();
      root.$store.commit('setMe', me.value);
      setAvailableDashboard();
    });

    const unauthorizeModal = ref(null);
    watch(() => root.$store.getters.unauthorizeModal, (newVal, oldVal) => {
      if (newVal && newVal !== oldVal) (unauthorizeModal.value as any).compose({ body: 'ท่านไม่ได้รับอนุญาตในการดำเนินการดังกล่าว หรือไม่มีสิทธิ์ในการเข้าถึงหน้านี้' });
    });
    function closeUnauthorizeModal() { root.$store.commit('setUnauthorizeModal', false); }

    const logoutConfirmModal = ref(null);

    const menuExpand = reactive({
      dashboard: false,
      store: false,
      partner: false,
      pr: false,
      po: false,
      wr: false,
      setting: false,
      job: false,
    });

    return {
      me,
      hasPermission,

      unauthorizeModal,
      closeUnauthorizeModal,

      menuExpand,

      logoutConfirmModal,
      dashboard,
    };
  },
});

export default AppFast;
